import { render, staticRenderFns } from "./UnassignedFaces.vue?vue&type=template&id=13b36322&scoped=true"
import script from "./UnassignedFaces.vue?vue&type=script&lang=js"
export * from "./UnassignedFaces.vue?vue&type=script&lang=js"
import style0 from "./UnassignedFaces.vue?vue&type=style&index=0&id=13b36322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b36322",
  null
  
)

export default component.exports